export const isSupportFileUpload = (
  fileName: string,
  allowFileTypes: string[],
): boolean => {
  const fileExtension = fileName.split(".").pop() || "";
  return allowFileTypes.indexOf(fileExtension.toLowerCase()) !== -1;
};
